module.exports = __webpack_public_path__ + "static/media/image-icon.bc5f3cb1.png";